import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import TicketType from '../../../../core/models/ticket.type';

@Component({
  selector: 'app-donation-ticket-modal',
  templateUrl: './donation-ticket-modal.component.html',
  styleUrls: ['./donation-ticket-modal.component.css']
})
export class DonationTicketModalComponent implements OnInit {
  @Input() ticketType!: TicketType;
  @Input() initialQty: number = 1;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<{ qty: number; amount: number }>();

  donationForm: FormGroup;
  minAmount: number = 0;

  constructor(private fb: FormBuilder) {
    this.donationForm = this.fb.group({
      qty: [1, [Validators.required, Validators.min(1)]],
      amount: [0, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.minAmount = Number(this.ticketType.min_donation_amount || 0) || Number(this.ticketType.price || 0) || 1;
    this.donationForm.patchValue({
      qty: this.initialQty > 0 ? this.initialQty : 1,
      amount: this.minAmount
    });
    this.donationForm.get('amount')?.addValidators(Validators.min(this.minAmount));
  }

  get qty() {
    return this.donationForm.get('qty')?.value;
  }

  get amount() {
    return this.donationForm.get('amount')?.value;
  }

  get total() {
    return this.qty * this.amount;
  }

  increaseQty() {
    this.donationForm.patchValue({ qty: this.qty + 1 });
  }

  decreaseQty() {
    if (this.qty > 1) {
      this.donationForm.patchValue({ qty: this.qty - 1 });
    }
  }

  onConfirm() {
    if (this.donationForm.valid) {
      this.confirm.emit({
        qty: this.qty,
        amount: Number(this.amount)
      });
    }
  }

  onClose() {
    this.close.emit();
  }

  onBlurAmount() {
    const currentAmount = Number(this.amount);
    if (!currentAmount || currentAmount < this.minAmount) {
      this.donationForm.patchValue({ amount: this.minAmount });
    }
  }
}
